$("[data-toggle='tooltip']").tooltip({
	trigger: 'hover'
});



// WEBPACK FOOTER //
// ./_dev/blocks/tooltip/tooltip.js